/**
 * @fileoverview Launcher flutuante do onboarding (FAB) exibido quando o modal está
 * minimizado. Mostra um anel de progresso com o percentual e reabre o modal ao
 * clicar. Fica acima do BottomNavigation no mobile.
 */

import React from "react";
import { makeStyles, useTheme, useMediaQuery } from "@material-ui/core";
import { Rocket } from "lucide-react";

import { i18n } from "../../../translate/i18n";
import { useOnboarding } from "../../../context/Onboarding/OnboardingContext";

const useStyles = makeStyles(theme => ({
  fab: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1250,
    width: 56,
    height: 56,
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    background: "linear-gradient(135deg, #4f7cff 0%, #3b82f6 100%)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 180ms cubic-bezier(0.4,0,0.2,1)",
    "&:hover": { transform: "translateY(-2px) scale(1.04)" },
    [theme.breakpoints.down("sm")]: {
      bottom: 76 // acima do BottomNavigation
    }
  },
  ring: { position: "absolute", inset: -3, transform: "rotate(-90deg)" },
  badge: {
    position: "absolute",
    top: -4,
    right: -4,
    minWidth: 20,
    height: 20,
    padding: "0 5px",
    borderRadius: 999,
    background: "#22c55e",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${theme.palette.type === "dark" ? "#0A0A0A" : "#fff"}`
  }
}));

const OnboardingLauncher = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { progress, setMinimized } = useOnboarding();
  // eslint-disable-next-line no-unused-vars
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!progress || !progress.visible || !progress.minimized) return null;

  const r = 27;
  const c = 2 * Math.PI * r;
  const dash = (progress.percent / 100) * c;

  return (
    <button
      type="button"
      className={classes.fab}
      onClick={() => setMinimized(false)}
      title={i18n.t("onboarding.title")}
      aria-label={i18n.t("onboarding.title")}
    >
      <svg className={classes.ring} width={62} height={62}>
        <circle cx={31} cy={31} r={r} fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth={3} />
        <circle
          cx={31}
          cy={31}
          r={r}
          fill="none"
          stroke="#fff"
          strokeWidth={3}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
        />
      </svg>
      <Rocket size={22} />
      <span className={classes.badge}>{progress.percent}%</span>
    </button>
  );
};

export default OnboardingLauncher;
